import { Configure, useCurrentRefinements, useHits, useInstantSearch } from 'react-instantsearch';
import { SearchContract } from '../search/product/SearchProductHit';
import { ProductHit } from '../search/search';

interface CompanyProductConfigureProps {
  isDownXl: boolean;
  filters: string;
  contract?: SearchContract;
}

export default function CompanyProductConfigure({ isDownXl, filters, contract }: CompanyProductConfigureProps): React.JSX.Element {
  const { results } = useHits<ProductHit>();
  const { indexUiState } = useInstantSearch();
  const { items: currentRefinements } = useCurrentRefinements();

  const hasContractWithOrders = !!contract?.order_count;
  const hasQuery = !!indexUiState.query || !!results?.query;
  const hasRefinements = currentRefinements.length > 0;

  const showLastOrderRecommendationState = hasContractWithOrders && !hasQuery && !hasRefinements;

  const hitsPerPage = showLastOrderRecommendationState
    ? (isDownXl ? 23 : 24)
    : (isDownXl ? 24 : 25);

  return (
    <Configure
      hitsPerPage={hitsPerPage}
      filters={filters}
    />
  );
}
